// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddBlogDetails-commonHeaderAdmin-PWaul {
	position: fixed !important;
}

.AddBlogDetails-adminLayout-Vg9WJ {
	padding-top: 64px !important;
}

.AddBlogDetails-box-gNung h2 {
	font-size: 21px;
	font-weight: 600;
}

.AddBlogDetails-exportLink-Id88g {
	margin-bottom: -29px;
}

.AddBlogDetails-blockCenter-TERU3 {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.AddBlogDetails-panelHeader-tW9L7 {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.AddBlogDetails-currencyselect-TMt33 {
	width: 100%;
	margin-right: 0px;
}

.AddBlogDetails-panelHeader-tW9L7 {
	overflow: hidden;
	position: relative;
}

.AddBlogDetails-mar0-v0csN {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.AddBlogDetails-blockCenter-TERU3 {
		padding: 0px;
	}

	.AddBlogDetails-panelHeader-tW9L7 {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.AddBlogDetails-sideAdminPageWrapper-Iij3m {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.AddBlogDetails-panelHeader-tW9L7 {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.AddBlogDetails-table-RD1ng {
	display: table;
}

.AddBlogDetails-tableRow-zKcow {
	display: table-row;
}

.AddBlogDetails-tableCell-jyvxv {
	display: table-cell;
	float: none;
}

.AddBlogDetails-formGroup-li5nf {
	margin-bottom: 6px;
}

.AddBlogDetails-select-TRIWz {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.AddBlogDetails-noMargin-LTWEv {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.AddBlogDetails-exportLink-Id88g {
	padding-top: 10px;
	padding-right: 10px;
}

.AddBlogDetails-labelTextNew-XH3P9 {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.AddBlogDetails-displayInline-skgFQ {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.AddBlogDetails-btnUPdate-jqdMm {
	display: inline-block;
}

.AddBlogDetails-btnModalDelete-g5Qe2 {
	display: inline-block;
	margin-left: 15px;
}

.AddBlogDetails-radioBtn-af3jc {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.AddBlogDetails-backgroundImg-cZnFj {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.AddBlogDetails-btnUPdate-jqdMm {
		display: block;
		margin-bottom: 12px;
	}

	.AddBlogDetails-btnModalDelete-g5Qe2 {
		display: block;
		margin-left: 0px;
	}

	.AddBlogDetails-btnWidth-pUxhh {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.AddBlogDetails-bannerImageBg-BrIap {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.AddBlogDetails-bannerDelete-NeQVR {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.AddBlogDetails-modalRoot-KO2fX {
	padding: 32px;
}

.AddBlogDetails-modalBorderBottom-pz4Eh {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.AddBlogDetails-logInModalBody-ckp5J {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.AddBlogDetails-exportSection-KTYlc {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.AddBlogDetails-exportSectionGridSub-S5v8f {
	grid-template-columns: 50% 49% !important;
}

.AddBlogDetails-exportText-Wprf1 {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.AddBlogDetails-exportLinkImg-IM8gA {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.AddBlogDetails-vtrMiddle-cZb1H {
	vertical-align: middle;
}

.AddBlogDetails-exportImg-Aw4Xf {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.AddBlogDetails-profileViewlabel-Z5WQP {
	display: inline-block;
	width: 38%
}

.AddBlogDetails-profileViewMainContent-O6CvB {
	display: inline-block;
	width: 62%;
}

.AddBlogDetails-profileViewMain-dgcTf {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.AddBlogDetails-profileViewInner-ebEPV {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.AddBlogDetails-profileImageSection-IpXHM {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.AddBlogDetails-lastviewInner-_ZhW3 {
	padding: 10px;
}

.AddBlogDetails-whyHostHoriLine-m7rU6 {
	margin: 30px 0;
}

.AddBlogDetails-tableGrid-pTyWg {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.AddBlogDetails-headingContent-EGe02 {
	font-size: 18px;
	font-weight: 500;
}

.AddBlogDetails-refundTextColor-kxCG0 {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.AddBlogDetails-dividerLine-V0KbM {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.AddBlogDetails-smallContent-tdSo0 {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.AddBlogDetails-sideAdminPageWrapper-Iij3m {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.AddBlogDetails-sideAdminPageWrapper-Iij3m {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.AddBlogDetails-exportSection-KTYlc {
		grid-template-columns: 100%;
	}

	.AddBlogDetails-exportSectionGridSub-S5v8f {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.AddBlogDetails-profileViewlabel-Z5WQP {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.AddBlogDetails-profileViewMainContent-O6CvB {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.AddBlogDetails-ChangeToUpperCase-Zx3XO {
	text-transform: uppercase
}

.AddBlogDetails-noBorder-kHEr4 {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.AddBlogDetails-siteAdminHeading-nI7z9 {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.AddBlogDetails-siteAdminSubHeading-QQw_b {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.AddBlogDetails-adminFormDivider-wSJ8m {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.AddBlogDetails-errorMessage-I3yRX {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.AddBlogDetails-panelHeader-tW9L7 {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.AddBlogDetails-formGroup-li5nf {
  margin-bottom: 6px;
}

.AddBlogDetails-select-TRIWz {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.AddBlogDetails-labelText-IMYaV {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.AddBlogDetails-space1-nhU2X {
	margin-bottom: 6px !important;
}

.AddBlogDetails-space2-b3WAY {
	margin-bottom: 12px !important;
}

.AddBlogDetails-space3-ixLwj {
	margin-bottom: 18px !important;
}

.AddBlogDetails-space4-iC5Oz {
	margin-bottom: 24px !important;
}

.AddBlogDetails-space5-rUbjT {
	margin-bottom: 30px !important;
}

.AddBlogDetails-space6-QgDX_ {
	margin-bottom: 36px !important;
}

.AddBlogDetails-space7-wYTMJ {
	margin-bottom: 42px !important;
}

.AddBlogDetails-spaceTop8-W8C1U {
	margin-bottom: 48px !important;
}

.AddBlogDetails-spaceTop1-thvt5 {
	margin-top: 6px !important;
}

.AddBlogDetails-spaceTop2-zvXqU {
	margin-top: 12px !important;
}

.AddBlogDetails-spaceTop3-yqq8V {
	margin-top: 18px !important;
}

.AddBlogDetails-spaceTop4-J8AzO {
	margin-top: 24px !important;
}

.AddBlogDetails-spaceTop5-hIcx3 {
	margin-top: 30px !important;
}

.AddBlogDetails-spaceTop6-YcXLr {
	margin-top: 36px !important;
}

.AddBlogDetails-spaceTop7-WZzB7 {
	margin-top: 42px !important;
}

.AddBlogDetails-spaceTop8-W8C1U {
	margin-top: 48px !important;
}

.AddBlogDetails-noMargin-LTWEv {
	margin: 0px !important;
}

.AddBlogDetails-padding1-aryVF {
	padding-bottom: 6px !important;
}

.AddBlogDetails-padding2-BhDLr {
	padding-bottom: 12px !important;
}

.AddBlogDetails-padding3-x162N {
	padding-bottom: 18px !important;
}

.AddBlogDetails-padding4-Ietab {
	padding-bottom: 24px !important;
}

.AddBlogDetails-padding5-dXPy2 {
	padding-bottom: 30px !important;
}

.AddBlogDetails-padding6-PXG3n {
	padding-bottom: 36px !important;
}

.AddBlogDetails-padding7-oZ_AQ {
	padding-bottom: 42px !important;
}

.AddBlogDetails-paddingTop1-GGqD0 {
	padding-top: 6px !important;
}

.AddBlogDetails-paddingTop2-wNAsj {
	padding-top: 12px !important;
}

.AddBlogDetails-paddingTop3-e0Tdg {
	padding-top: 18px !important;
}

.AddBlogDetails-paddingTop4-l8Ypj {
	padding-top: 24px !important;
}

.AddBlogDetails-paddingTop5-zHc3b {
	padding-top: 30px !important;
}

.AddBlogDetails-paddingTop6-rpaab {
	padding-top: 36px !important;
}

.AddBlogDetails-paddingTop7-sVNVU {
	padding-top: 42px !important;
}

.AddBlogDetails-noPadding-Kt0rQ {
	padding: 0px !important;
}

.AddBlogDetails-textBold-wdXr3 {
	font-weight: 500 !important;
}

.AddBlogDetails-textBolder-dzM5V {
	font-weight: 700 !important;
}

.AddBlogDetails-textNormal-Ek6jR {
	font-weight: normal !important;
}

.AddBlogDetails-spaceBottom20-y5mgR {
	margin-bottom: 20px;
}

.AddBlogDetails-spaceBottom10-UGbvy {
	margin-bottom: 10px;
}

.AddBlogDetails-marginNone-BtDUS {
	margin: 0;
}

.AddBlogDetails-spaceBottom15-uhaHJ {
	margin-bottom: 15px;
}

.AddBlogDetails-marginTopNone-djcNX {
	margin-top: 0;
}

.AddBlogDetails-spaceTop11-lYOMG {
	margin-top: 11px;
}

.AddBlogDetails-spaceTop21-Rt0Wd {
	margin-top: 21px;
}

.AddBlogDetails-spaceTop20-Tdmpk {
	margin-top: 20px;
}

.AddBlogDetails-spaceTop10-saYsH {
	margin-top: 10px;
}

/*New Design Text Colors */

.AddBlogDetails-textDarkBlue-rpbpO {
	color: rgb(20, 39, 94) !important;
}

.AddBlogDetails-textLightBlue-gFNXs {
	color: rgb(57, 87, 106) !important;
}

.AddBlogDetails-textLightSandleGreen-Y3dFo {
	color: rgb(76, 86, 41) !important;
}

.AddBlogDetails-textLightBrown-ufotR {
	color: rgb(115, 79, 33) !important;
}

.AddBlogDetails-textMediumMaroon-yuvx5 {
	color: rgb(87, 37, 51) !important;
}

.AddBlogDetails-textBrown-uDoCa {
	color: rgb(160, 47, 24) !important;
}

.AddBlogDetails-textMaroon-WLLCd {
	color: rgb(155, 49, 67) !important;
}

.AddBlogDetails-textDarkBrown-jnTuc {
	color: rgb(83, 18, 16) !important;
}

.AddBlogDetails-textMediumBrown-JHN1Y {
	color: rgb(142, 28, 10) !important;
}

.AddBlogDetails-textSkyBlue-f6ZXy {
	color: rgb(37, 117, 141) !important;
}

.AddBlogDetails-textGray-joDYL {
	color: rgb(77, 65, 51) !important;
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `AddBlogDetails-commonHeaderAdmin-PWaul`,
	"adminLayout": `AddBlogDetails-adminLayout-Vg9WJ`,
	"box": `AddBlogDetails-box-gNung`,
	"exportLink": `AddBlogDetails-exportLink-Id88g`,
	"blockCenter": `AddBlogDetails-blockCenter-TERU3`,
	"panelHeader": `AddBlogDetails-panelHeader-tW9L7`,
	"currencyselect": `AddBlogDetails-currencyselect-TMt33`,
	"mar0": `AddBlogDetails-mar0-v0csN`,
	"sideAdminPageWrapper": `AddBlogDetails-sideAdminPageWrapper-Iij3m`,
	"table": `AddBlogDetails-table-RD1ng`,
	"tableRow": `AddBlogDetails-tableRow-zKcow`,
	"tableCell": `AddBlogDetails-tableCell-jyvxv`,
	"formGroup": `AddBlogDetails-formGroup-li5nf`,
	"select": `AddBlogDetails-select-TRIWz`,
	"noMargin": `AddBlogDetails-noMargin-LTWEv`,
	"labelTextNew": `AddBlogDetails-labelTextNew-XH3P9`,
	"displayInline": `AddBlogDetails-displayInline-skgFQ`,
	"btnUPdate": `AddBlogDetails-btnUPdate-jqdMm`,
	"btnModalDelete": `AddBlogDetails-btnModalDelete-g5Qe2`,
	"radioBtn": `AddBlogDetails-radioBtn-af3jc`,
	"backgroundImg": `AddBlogDetails-backgroundImg-cZnFj`,
	"btnWidth": `AddBlogDetails-btnWidth-pUxhh`,
	"bannerImageBg": `AddBlogDetails-bannerImageBg-BrIap`,
	"bannerDelete": `AddBlogDetails-bannerDelete-NeQVR`,
	"modalRoot": `AddBlogDetails-modalRoot-KO2fX`,
	"modalBorderBottom": `AddBlogDetails-modalBorderBottom-pz4Eh`,
	"logInModalBody": `AddBlogDetails-logInModalBody-ckp5J`,
	"exportSection": `AddBlogDetails-exportSection-KTYlc`,
	"exportSectionGridSub": `AddBlogDetails-exportSectionGridSub-S5v8f`,
	"exportText": `AddBlogDetails-exportText-Wprf1`,
	"exportLinkImg": `AddBlogDetails-exportLinkImg-IM8gA`,
	"vtrMiddle": `AddBlogDetails-vtrMiddle-cZb1H`,
	"exportImg": `AddBlogDetails-exportImg-Aw4Xf`,
	"profileViewlabel": `AddBlogDetails-profileViewlabel-Z5WQP`,
	"profileViewMainContent": `AddBlogDetails-profileViewMainContent-O6CvB`,
	"profileViewMain": `AddBlogDetails-profileViewMain-dgcTf`,
	"profileViewInner": `AddBlogDetails-profileViewInner-ebEPV`,
	"profileImageSection": `AddBlogDetails-profileImageSection-IpXHM`,
	"lastviewInner": `AddBlogDetails-lastviewInner-_ZhW3`,
	"whyHostHoriLine": `AddBlogDetails-whyHostHoriLine-m7rU6`,
	"tableGrid": `AddBlogDetails-tableGrid-pTyWg`,
	"headingContent": `AddBlogDetails-headingContent-EGe02`,
	"refundTextColor": `AddBlogDetails-refundTextColor-kxCG0`,
	"dividerLine": `AddBlogDetails-dividerLine-V0KbM`,
	"smallContent": `AddBlogDetails-smallContent-tdSo0`,
	"ChangeToUpperCase": `AddBlogDetails-ChangeToUpperCase-Zx3XO`,
	"noBorder": `AddBlogDetails-noBorder-kHEr4`,
	"siteAdminHeading": `AddBlogDetails-siteAdminHeading-nI7z9`,
	"siteAdminSubHeading": `AddBlogDetails-siteAdminSubHeading-QQw_b`,
	"adminFormDivider": `AddBlogDetails-adminFormDivider-wSJ8m`,
	"errorMessage": `AddBlogDetails-errorMessage-I3yRX`,
	"labelText": `AddBlogDetails-labelText-IMYaV`,
	"space1": `AddBlogDetails-space1-nhU2X`,
	"space2": `AddBlogDetails-space2-b3WAY`,
	"space3": `AddBlogDetails-space3-ixLwj`,
	"space4": `AddBlogDetails-space4-iC5Oz`,
	"space5": `AddBlogDetails-space5-rUbjT`,
	"space6": `AddBlogDetails-space6-QgDX_`,
	"space7": `AddBlogDetails-space7-wYTMJ`,
	"spaceTop8": `AddBlogDetails-spaceTop8-W8C1U`,
	"spaceTop1": `AddBlogDetails-spaceTop1-thvt5`,
	"spaceTop2": `AddBlogDetails-spaceTop2-zvXqU`,
	"spaceTop3": `AddBlogDetails-spaceTop3-yqq8V`,
	"spaceTop4": `AddBlogDetails-spaceTop4-J8AzO`,
	"spaceTop5": `AddBlogDetails-spaceTop5-hIcx3`,
	"spaceTop6": `AddBlogDetails-spaceTop6-YcXLr`,
	"spaceTop7": `AddBlogDetails-spaceTop7-WZzB7`,
	"padding1": `AddBlogDetails-padding1-aryVF`,
	"padding2": `AddBlogDetails-padding2-BhDLr`,
	"padding3": `AddBlogDetails-padding3-x162N`,
	"padding4": `AddBlogDetails-padding4-Ietab`,
	"padding5": `AddBlogDetails-padding5-dXPy2`,
	"padding6": `AddBlogDetails-padding6-PXG3n`,
	"padding7": `AddBlogDetails-padding7-oZ_AQ`,
	"paddingTop1": `AddBlogDetails-paddingTop1-GGqD0`,
	"paddingTop2": `AddBlogDetails-paddingTop2-wNAsj`,
	"paddingTop3": `AddBlogDetails-paddingTop3-e0Tdg`,
	"paddingTop4": `AddBlogDetails-paddingTop4-l8Ypj`,
	"paddingTop5": `AddBlogDetails-paddingTop5-zHc3b`,
	"paddingTop6": `AddBlogDetails-paddingTop6-rpaab`,
	"paddingTop7": `AddBlogDetails-paddingTop7-sVNVU`,
	"noPadding": `AddBlogDetails-noPadding-Kt0rQ`,
	"textBold": `AddBlogDetails-textBold-wdXr3`,
	"textBolder": `AddBlogDetails-textBolder-dzM5V`,
	"textNormal": `AddBlogDetails-textNormal-Ek6jR`,
	"spaceBottom20": `AddBlogDetails-spaceBottom20-y5mgR`,
	"spaceBottom10": `AddBlogDetails-spaceBottom10-UGbvy`,
	"marginNone": `AddBlogDetails-marginNone-BtDUS`,
	"spaceBottom15": `AddBlogDetails-spaceBottom15-uhaHJ`,
	"marginTopNone": `AddBlogDetails-marginTopNone-djcNX`,
	"spaceTop11": `AddBlogDetails-spaceTop11-lYOMG`,
	"spaceTop21": `AddBlogDetails-spaceTop21-Rt0Wd`,
	"spaceTop20": `AddBlogDetails-spaceTop20-Tdmpk`,
	"spaceTop10": `AddBlogDetails-spaceTop10-saYsH`,
	"textDarkBlue": `AddBlogDetails-textDarkBlue-rpbpO`,
	"textLightBlue": `AddBlogDetails-textLightBlue-gFNXs`,
	"textLightSandleGreen": `AddBlogDetails-textLightSandleGreen-Y3dFo`,
	"textLightBrown": `AddBlogDetails-textLightBrown-ufotR`,
	"textMediumMaroon": `AddBlogDetails-textMediumMaroon-yuvx5`,
	"textBrown": `AddBlogDetails-textBrown-uDoCa`,
	"textMaroon": `AddBlogDetails-textMaroon-WLLCd`,
	"textDarkBrown": `AddBlogDetails-textDarkBrown-jnTuc`,
	"textMediumBrown": `AddBlogDetails-textMediumBrown-JHN1Y`,
	"textSkyBlue": `AddBlogDetails-textSkyBlue-f6ZXy`,
	"textGray": `AddBlogDetails-textGray-joDYL`
};
module.exports = ___CSS_LOADER_EXPORT___;
